<template>
  <div class="boxshell">
    <div class="box">
      <div id="codeDiv" style="display: none;" ref="qrCodeUrl"></div>
      <div class="scanCodeBox"><div class="qrcode" id="qrcode"></div></div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';

export default {
  name: 'CreateQrCode',
  data() {
    return {
      imageBox: null,
      qrcode: null,
    };
  },
  props: ['generateImg', 'qrCodeurl'],
  watch: {
    qrCodeurl: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.creatQrCode(val);
        }
      },
    },
  },
  methods: {
    creatQrCode(url) {
      // 获取父元素
      const content = document.getElementById('qrcode');
      const codeDiv = document.getElementById('codeDiv');
      // 循环删除子元素，一直删除第一个子元素直到没有子元素即为清空
      while (codeDiv.hasChildNodes()) {
        codeDiv.removeChild(codeDiv.firstChild);
      }
      // 循环删除子元素，一直删除第一个子元素直到没有子元素即为清空
      while (content.hasChildNodes()) {
        content.removeChild(content.firstChild);
      }
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        margin: 10,
        correctLevel: QRCode.CorrectLevel.H,
      });
      const canvas = document.getElementsByTagName('canvas')[0];
      const img = this.convertCanvasToImage(canvas);
      document.getElementById('qrcode').appendChild(img);
    },
    convertCanvasToImage(canvas) {
      // 新建Image对象
      this.imageBox = new Image();
      this.imageBox.style.width = '100%';
      // canvas.toDataURL 返回的是一串Base64编码的URL
      this.imageBox.src = canvas.toDataURL('image/png');
      console.log(canvas, '99999');
      this.generateImg(this.imageBox);
      return this.imageBox;
    },
  },
};
</script>
<style scoped>
.boxshell {
  padding: 4px 40px;
  display: flex;
  align-items: center;
  height: 100%;
}
.box {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  border-radius: 16px;
  box-sizing: border-box;
}
.scanCodeBox {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  box-sizing: border-box;
}
.tipTopStyle {
  font-size: 17px;
  color: #1c2438;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
  margin-top: 16px;
}
.tipLowStyle {
  font-size: 14px;
  color: #495060;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
  margin-top: 4px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
}
</style>
